import request from '@/utils/request'

// 根据类型查询文章
export function histroyList(query) {
  return request({
    url: '/web/histroy/histroyList',
    method: 'get',
    params: query
  })
}